'use client'

import { PropsWithChildren, useState } from 'react'
import { Box } from '@chakra-ui/react'

import { CustomerInfo } from 'app/utils/authentication'

import SelectUserOrganizationDropdown from './SelectUserOrganizationDropdown'

type Props = PropsWithChildren & {
  customerInfo: CustomerInfo
  customerHasOrganizations: boolean
}

const LoggedInAvatarClientPart = ({
  children,
  customerInfo,
  customerHasOrganizations: customerHasOrganization,
}: Props): JSX.Element => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <Box
      width="40px"
      position="relative"
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
    >
      <Box _hover={{ textDecor: 'none' }} className="">
        {children}

        {customerHasOrganization && (
          <>
            <SelectUserOrganizationDropdown isOpen={isDropdownOpen} customerInfo={customerInfo} />
          </>
        )}
      </Box>
    </Box>
  )
}

export default LoggedInAvatarClientPart
